import $ from "jquery";
import { i18n } from "../../common/translations";
import {GAEvent} from "../../common/google_analytics/google_analytics";
import { constants } from "../../common/constants/constants";
import {BllinkLogger} from "../../common/utils/bllink_loggers";
require('jquery-validation');

export default class BankDetailsLogic{

    static validateCreateForm(validator, thisObj){

        BllinkLogger.info(`validateCreateForm add bank details validator `, validator);
        if (validator){
            BllinkLogger.info('destroy validation create bank details ')
            BllinkLogger.info(validator.destroy());
        }


        // Initialize form validation on the registration form.
        // It has the name attribute "registration"
        validator = $("form[id='js-add-bank-details-form']").validate({
            // Specify validation rules
            rules: {
                "full-name": "required",
                "branch_number": "required",
                "account-number": "required",
                "js-bank-code": "required",
                "terms-of-use": "required",
                "proof-of-ownership": "required",
            },
            // Specify validation error messages
            messages: {
                "full-name": i18n.t('titles.forms.mandatory_field'),
                "branch_number": i18n.t('titles.forms.mandatory_field'),
                "account-number": i18n.t('titles.forms.mandatory_field'),
                "js-bank-code": i18n.t('titles.forms.mandatory_field'),
                "terms-of-use": i18n.t('titles.forms.mandatory_field'),
                "proof-of-ownership": i18n.t('titles.forms.mandatory_field'),
            },

            // Make sure the form is submitted to the destination defined
            // in the "action" attribute of the form when valid
            submitHandler: async function(form) {
                GAEvent(constants.GoogleAnalytics.Events.addBankDetails, 'success', 1, 'success');
                await thisObj.saveDetails();
            },

            invalidHandler: function(form, validator) {
                for (const error of validator.errorList){
                    GAEvent(constants.GoogleAnalytics.Events.addBankDetails, 'validationError', 1, $(error.element).attr('name'));
                }
            }
        });

        return validator
    }
}
